import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { ButtonBase, IconButton } from '@material-ui/core'
import styles from '../../../styles'
import Icon from '../../../components/icon/Icon'
import AppBar from '@material-ui/core/AppBar'
import { animateScroll as scroll, scroller } from 'react-scroll'
import { ModelCategory } from '../../../types/faq/faq_model'
import { Sticky, StickyContainer } from 'react-sticky'
import iconsEnum from '../../../enums/iconsEnum'

export const offSet = -266

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		faqSubMenu: {
			marginTop: 42,
			width: '100%',
			display: 'flex',
			alignItems: 'center',
			flexDirection: 'column'
		},

		faqSubMenuButton: {
			display: 'flex',
			width: '100%',
			justifyContent: 'space-evenly',
			alignItems: 'center',

			'& button': {
				'&#iconButton': {
					display: 'flex',
					width: 49,
					height: 49,
					fill: '#fff',
					backgroundColor: theme.palette.dynamic.main,
					marginRight: 12,
					'&:hover': {
						backgroundColor: theme.palette.dynamic['50'],
						boxShadow: 'none',
						fill: theme.palette.blue.main
					}
				},
				'&#basicsButton': {
					backgroundColor: 'white',
					width: '22%',
					height: 80,
					borderRadius: 40,
					'&:hover': {
						backgroundColor: theme.palette.accessibility.main,
						'& svg': {
							fill: 'white'
						},
						'& span': {
							color: 'white'
						}
					}
				}
			}
		},
		faqSubMenuButtonTitle: {
			marginLeft: 14,
			width: 'min-content',
			minWidth: 110
		},
		icon: {
			fill: theme.palette.blue.main
		},
		appBar: {
			padding: '20px 0px',
			marginBottom: 22,
			backgroundColor: theme.palette.blue['5'],
			zIndex: 1
		},
		appBarRelative: {
			position: 'relative'
		},
		appBarFixed: {
			position: 'fixed',
			width: '80%',
			maxWidth: 1100,

			left: '50%',
			top: 100,
			transform: 'translate(-50%)'
		},
		stickyContainerStyle: {
			width: '100%'
		},
		faqSubMenuContainer: {
			height: 166
		}
	}
))

interface AcceptingProps {
	categories: Array<ModelCategory>,
}

type FaqHeaderSubmenuProps = AcceptingProps

const FaqHeaderSubmenu: React.FC<FaqHeaderSubmenuProps> = (
	{
		categories
	}
) => {

	const classes = useStyle()

	const categoryClass = classNames(
		classes.title4,
		classes.colorBlue,
		classes.faqSubMenuButtonTitle
	)

	const titleSubMenu = classNames(
		classes.semiBold,
		classes.colorBlue,
		classes.text1
	)

	const onClickScrollTo = (name: string, offsetScroll: number) => {
		scroller.scrollTo(name, {
			duration: 1500,
			delay: 100,
			smooth: true,
			offset: offsetScroll
		})
	}

	return (
		<div className={classes.faqSubMenuContainer}>
			<div className={classes.faqSubMenu}>
                 <span
	                 className={titleSubMenu}
                 >
                    <FormattedMessage
	                    id="faq.category"
	                    defaultMessage="Ou choisissez une catégorie de questions fréquentes "
	                    description="Faq header subMenu title"
                    />
                 </span>
			</div>

			<StickyContainer className={classes.stickyContainerStyle}>
				<Sticky>
					{
						(
							{
								distanceFromTop
							}
						) => {
							return (
								<AppBar
									elevation={0}
									className={
										classNames(
											{
												[classes.appBarFixed]: distanceFromTop <= 100,
												[classes.appBarRelative]: distanceFromTop > 100 || !distanceFromTop
											},
											classes.appBar
										)
									}
								>
			                        <span className={classes.faqSubMenuButton}>
			                            {
				                            categories.map(
					                            (category: ModelCategory, key) =>
						                            category.themes && category.themes.length > 0 &&
						                            <ButtonBase
							                            id="basicsButton"
							                            key={key}
							                            onClick={() => onClickScrollTo(category.name, offSet)}
						                            >
							                            <Icon icon={category.icon ? iconsEnum[category.icon] : iconsEnum.Default} size={40}
							                                  className={classes.icon} />
							                            <span
								                            className={categoryClass}
							                            >
			                                                {category.name}
			                                            </span>
						                            </ButtonBase>
				                            )
			                            }
				                        {
					                        distanceFromTop <= 200 &&
					                        <IconButton id="iconButton"
					                                    onClick={scroll.scrollToTop}>
						                        <Icon size="100%" icon={iconsEnum.Search2} />
					                        </IconButton>
				                        }
			                        </span>
								</AppBar>
							)
						}
					}
				</Sticky>
			</StickyContainer>
		</div>
	)
}

export default FaqHeaderSubmenu
